var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.154,
    height: 24.321,
    viewBox: "0 0 26.154 24.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(-0.296 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M15.167,19.271V16.608a.447.447,0,0,0-.133-.329.431.431,0,0,0-.315-.133H12.028a.431.431,0,0,0-.315.133.447.447,0,0,0-.133.329v2.663a.447.447,0,0,0,.133.329.431.431,0,0,0,.315.133h2.691a.431.431,0,0,0,.315-.133A.447.447,0,0,0,15.167,19.271Zm-.028-5.242L15.391,7.6a.309.309,0,0,0-.14-.266.542.542,0,0,0-.336-.154H11.831a.542.542,0,0,0-.336.154.335.335,0,0,0-.14.294l.238,6.4a.269.269,0,0,0,.14.231.6.6,0,0,0,.336.091h2.593a.57.57,0,0,0,.329-.091A.312.312,0,0,0,15.139,14.029Zm-.2-13.09L25.707,20.672a1.672,1.672,0,0,1-.028,1.766,1.793,1.793,0,0,1-1.542.883H2.609a1.793,1.793,0,0,1-1.542-.883,1.672,1.672,0,0,1-.028-1.766L11.8.939a1.79,1.79,0,0,1,.659-.687,1.771,1.771,0,0,1,1.822,0A1.79,1.79,0,0,1,14.943.939Z",
    transform: "translate(0 0)",
    fill: "#ff0505",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.22517867b9abacd5d293504387efbd19.svg";
export { ForwardRef as ReactComponent };